import React, {useEffect, useState} from 'react';
import style from "./OrdersAvailableCard.module.scss"
import cn from "classnames";
import {numberToFinanceFormat, requestErrorDisplay} from "../../../../utils";
import moment from "moment";
import {Order} from "../../../../services";
import {useSelector} from "react-redux";
import DeleteIcon from "../../../shared/icons/DeleteIcon";
import EditIcon from "../../../shared/icons/EditIcon";
import {Link} from "react-router-dom";
import Loading from "../../../shared/Loading/Loading";
import Badge from '../../../shared/Badge';
import Driver from '../../driver';
import {ORDER_STATUSES_DATA} from "../../../../mock";
import { useTranslation } from 'react-i18next';
import AppTooltip from '../../../shared/AppTooltip/AppTooltip';

const OrdersAvailableCard = ({
                                order,
                                setOrderActive,
                                isDraftItem = false,
                                isOrdersInProgressPage = false,
                                isLoading,
                                onDelete
}) => {
  const { t } = useTranslation();
  const { user } = useSelector(state => state);
  const [cargoInfo, setCargoInfo] = useState(null)
  const [countryFromName, setCountryFromName] = useState(order.countryFromName || '')
  const [countryToName, setCountryToName] = useState(order.countryToName || '')
  const [cityFromName, setCityFromName] = useState(order.cityFromName || '')
  const [cityToName, setCityToName] = useState(order.cityToName || '')
  const [shippingDate, setShippingDate] = useState(null)
  const [unloadingDate, setUnloadingDate] = useState(null)
  const [distance, setDistance] = useState(order.distance || 0)
  const [isLoadingData, setIsLoadingData] = useState(false)


  useEffect(() => {
    console.log("Order data received:", order);

    if (order.jsonData) {
      try {
        const parsedData = JSON.parse(order.jsonData);

        if (parsedData.Distance) {
          setDistance(parsedData.Distance);
        }

        if (parsedData.ShippingDate) {
          setShippingDate(parsedData.ShippingDate);
        }

        if (parsedData.UnloadingDate) {
          setUnloadingDate(parsedData.UnloadingDate);
        }

        if (parsedData.AddressFrom) {
          setCityFromName(prev => prev || parsedData.AddressFrom);
        }

        if (parsedData.AddressTo) {
          setCityToName(prev => prev || parsedData.AddressTo);
        }
      } catch (error) {
        console.error("Error parsing JSON data:", error);
      }
    }

    getCargo()

    if (isDraftItem) {
      getDraftValues()
    }
  }, [order])

  const onRemove = e => {
    e.preventDefault()
    e.stopPropagation()
    if (onDelete) onDelete()
  }

  const getDraftValues = () => {
    console.log("Draft values to fetch:", {
      countryIdFrom: order.countryIdFrom,
      countryIdTo: order.countryIdTo,
      cityIdFrom: order.cityIdFrom,
      cityIdTo: order.cityIdTo
    });

    setIsLoadingData(true)

    let countryIdFrom = order.countryIdFrom;
    let countryIdTo = order.countryIdTo;
    let cityIdFrom = order.cityIdFrom;
    let cityIdTo = order.cityIdTo;

    if (order.jsonData) {
      try {
        const parsedData = JSON.parse(order.jsonData);
        countryIdFrom = countryIdFrom || parsedData.CountryIdFrom;
        countryIdTo = countryIdTo || parsedData.CountryIdTo;
        cityIdFrom = cityIdFrom || parsedData.CityIdFrom;
        cityIdTo = cityIdTo || parsedData.CityIdTo;
      } catch (error) {
        console.error("Error parsing JSON data for IDs:", error);
      }
    }

    const requests = [
      {
        item: countryIdFrom,
        itemKey: "name",
        setEvent: setCountryFromName,
        apiName: "getCountryById",
      },
      {
        item: countryIdTo,
        itemKey: "name",
        setEvent: setCountryToName,
        apiName: "getCountryById"
      },
      {
        item: cityIdFrom,
        itemKey: "name",
        setEvent: setCityFromName,
        apiName: "getCityById"
      },
      {
        item: cityIdTo,
        itemKey: "name",
        setEvent: setCityToName,
        apiName: "getCityById"
      }
    ]

    const apiPromises = [];

    requests.forEach(req => {
      if (req.item) {
        const promise = Order[req.apiName](req.item)
          .then(res => res.data)
          .then((data) => {
            if (data && data[req.itemKey]) {
              req.setEvent(data[req.itemKey])
            }
          })
          .catch((error) => {
            console.log(`get [${req.apiName}] error:`, error);
            requestErrorDisplay(error, "Произошла ошибка, попробуйте позже")
          });

        apiPromises.push(promise);
      }
    })

    Promise.allSettled(apiPromises).then(() => {
      setIsLoadingData(false);
    });
  }

  const getCargo = () => {
    if (isDraftItem && !order.cargoId) {
      return
    }
    Order.getCargo(order.cargoId)
      .then(res => res.data)
      .then((response) => {
        setCargoInfo(response)
        console.log("get cargo", response);
      })
      .catch((error) => {
        console.log("get cargo error:", error);
        requestErrorDisplay(error, "Произошла ошибка, попробуйте позже")
      });
  }
  const handleClick = () => {
    setOrderActive(order)
  }

  const setDefaultText = (val, placeholder) => {
    if (!val) {
      return placeholder
    }
    return val
  }

  const formatDateTime = inputDate => {
    if (!inputDate) return '';

    const date = moment(inputDate);
    const today = moment();
    const yesterday = moment().subtract(1, 'day');

    if (date.isSame(today, 'day')) {
      return `Сегодня в ${date.format('HH:mm')}`;
    }
    if (date.isSame(yesterday, 'day')) {
      return `Вчера в ${date.format('HH:mm')}`;
    }
    return date.format('MMMM DD, YYYY');
  }

  return (
    <>
      <div
        className={cn(style.wrapper, {
          [style.wrapper_draft]: isDraftItem,
          [style.wrapper_withLoading]: isLoading || isLoadingData
        })}
        onClick={handleClick}
      >
        <div
          className={cn(style.item, style.width_200, {
            [style.row2]: !isDraftItem && !isOrdersInProgressPage,
            [style.width_90]: isOrdersInProgressPage,
          })}
        >
          {
            isDraftItem
              ? (
                <>
                  <div className={cn(style.actions, style.mr16)}>
                    <Link
                      to={`/orders/draft/${order.id}/edit`}
                      className={style.button}
                      data-tooltip-id="draft-card-edit-tooltip"
                    >
                      <EditIcon fill={"#C3C5CA"} />
                    </Link>
                    <AppTooltip id="draft-card-edit-tooltip" place="top" positionStrategy="fixed">
                      {t('tooltips.edit')}
                    </AppTooltip>
                    <button
                      type={"button"}
                      className={style.button}
                      onClick={onRemove}
                      data-tooltip-id="draft-card-delete-tooltip"
                    >
                      <DeleteIcon fill={"#C3C5CA"} />
                    </button>
                    <AppTooltip id="draft-card-delete-tooltip" place="top" positionStrategy="fixed">
                      {t('tooltips.delete')}
                    </AppTooltip>
                  </div>
                  <span className={cn(style.tag, style.tag__small)}>{t('ordersDraftList.draftItem.title')}</span>
                </>
              )
              : (
                <>
                  <span className={style.textBold}>№{order.number}</span>
                  <span className={cn(style.textGray, { [style.hide]: isOrdersInProgressPage })}>
                    { formatDateTime(order.createdAt) }
                  </span>
                </>
              )
          }
        </div>
        {
          isOrdersInProgressPage && (
            <div className={cn(style.item, style.width_250)}>
              <Badge type={"blue"} text={ORDER_STATUSES_DATA(t)[order.status]?.title || 'Неизвестный статус'} />
            </div>
          )
        }
        <div className={cn(style.item, style.row2, {
          [style.item_address]: !isDraftItem
        })}>
          <div className={style.address}>
            <img src={'/icons/sender.svg'} alt="icon" />
            <span className={style.textBold}>
              {setDefaultText(cityFromName, t("ordersDraftList.loadingCityNotSpecified"))}{countryFromName ? `, ${countryFromName}` : ''}
            </span>
            <span className={style.textGray}>
              { shippingDate ? moment(shippingDate).format("DD MMMM") : (order.shippingDate ? moment(order.shippingDate).format("DD MMMM") : t("ordersDraftList.loadingDateNotSpecified")) }
            </span>
          </div>
          <div className={style.address}>
            <img src={'/icons/location-color.svg'} alt="icon" />
            <span className={style.textBold}>
              {setDefaultText(cityToName, t("ordersDraftList.unloadingCityNotSpecified"))}{countryToName ? `, ${countryToName}` : ''}
            </span>
            <span className={style.textGray}>
              { unloadingDate ? moment(unloadingDate).format("DD MMMM") : (order.unloadingDate ? moment(order.unloadingDate).format("DD MMMM") : t("ordersDraftList.loadingDateNotSpecified")) }
            </span>
          </div>
        </div>

        <div className={cn(style.item, style.distance, style.width_100, { [style.row2]: false } )}>
          <span>{numberToFinanceFormat(distance || order.distance || 0)} {t("analytics.distance_metric")}</span>
          { false }
        </div>

        <div
          className={cn(style.item, {
            [style.types]: !isOrdersInProgressPage,
            [style.hide]: isOrdersInProgressPage,
          })}
        >
          {
            (cargoInfo || isDraftItem) && (
              <>
                {/*<OrdersTransportType isTagView draft={isDraftItem} type={isDraftItem ? order.vehicleType : cargoInfo?.vehicleType} text={cargoInfo?.vehicleTypeName} />*/}
                {/*<span className={style.tag}>*/}
                {/*  <WeightIcon />*/}
                {/*  {cargoInfo?.weight || order?.weight} { !(cargoInfo?.weight || order?.weight) && isDraftItem ? "Не указан" : "т" }*/}
                {/*</span>*/}
                {/*<span className={style.tag}>*/}
                {/*  <FullScreenIcon />*/}
                {/*  {cargoInfo?.volume || order?.volume}  { !(cargoInfo?.volume || order?.volume) && isDraftItem ? "Не указан" : (<>м<sup>3</sup></>) }*/}
                {/*</span>*/}
                {/*{*/}
                {/*  cargoInfo?.categoryName && (*/}
                {/*    <span className={style.tag}>*/}
                {/*      {cargoInfo?.categoryName}*/}
                {/*    </span>*/}
                {/*  )*/}
                {/*}*/}
              </>
            )
          }
        </div>
        {
          isOrdersInProgressPage && (
            <>
              <div
                className={cn(style.item)}
              >
                <Driver.DriverTransport
                  item={{
                    carModel: order.carModel,
                    carNumber: order.carNumber,
                    vehicleTypeName: cargoInfo?.vehicleTypeName,
                    loadingTypeName: cargoInfo?.loadingTypeName,
                  }}
                  displayStatus={false}
                  withoutBgAndPadding
                />
              </div>
              <div
                className={cn(style.item)}
              >
                <Driver.DriverCard
                  item={{
                    id: order.driverId,
                    surname: order.driverSurname,
                    name: order.driverName,
                    patronymic: order.driverPatronymic,
                    phoneNumber: order.driverPhoneNumber,
                  }}
                  displayStatus={false}
                  withoutBgAndPadding
                />
              </div>
            </>
          )
        }
        {
          !isDraftItem && (
          <div
            className={cn(style.item, style.row2, style.contentRight, style.width_150)}
          >
            <span className={style.textBold}>
              {numberToFinanceFormat(order.price)}₸
            </span>
            <span className={style.textGray}>
              {Math.round(order.price / order.distance)}₸/{t("analytics.distance_metric")}
            </span>
          </div>
          )
        }
        { isLoading && (
          <div className={style.loading}>
            <Loading inBlock marginBottom={0} />
          </div>
        )}
      </div>
    </>
  );
};

export default OrdersAvailableCard;